import { render, staticRenderFns } from "./BulkCuratedUpload.vue?vue&type=template&id=b1c87e6a&scoped=true"
import script from "./BulkCuratedUpload.vue?vue&type=script&lang=ts"
export * from "./BulkCuratedUpload.vue?vue&type=script&lang=ts"
import style0 from "./BulkCuratedUpload.vue?vue&type=style&index=0&id=b1c87e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c87e6a",
  null
  
)

export default component.exports